(function ($) {

    var initializeBlock = function ($block) {
        $block.find('.faq-question').click(function (event) {
            $(this).parent('.faq').toggleClass('open');
        });
    }

    $(document).ready(function () {
        $('.block--faqs').each(function () {
            initializeBlock($(this));
        })
    })

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=faqs', initializeBlock);
    }

})(jQuery);
